import moment from 'moment';
import 'moment-timezone';

export default {
    data() {
        return {
            start: null,
            end: null,
            selectedPreset: 'last15min'
        };
    },
    methods: {
        getEasternMoment() {
            return moment().tz('America/New_York');
        },
         formatDateFromResults(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
             const day = String(date.getDate()).padStart(2, "0");
             const hours = String(date.getHours()).padStart(2, "0");
             const minutes = String(date.getMinutes()).padStart(2, "0");
             const seconds = String(date.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        },

        setDateRange(preset) {
            this.selectedPreset = preset;
            const eastern = this.getEasternMoment();

            switch(preset) {
                // Relative ranges
                case 'last2days':
                    this.start = eastern.clone().subtract(2, 'days').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last7days':
                    this.start = eastern.clone().subtract(7, 'days').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last30days':
                    this.start = eastern.clone().subtract(30, 'days').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last3months':
                    this.start = eastern.clone().subtract(3, 'months');
                    this.end = eastern.clone();
                    break;
                case 'last6months':
                    this.start = eastern.clone().subtract(6, 'months');
                    this.end = eastern.clone();
                    break;
                case 'last1year':
                    this.start = eastern.clone().subtract(1, 'year');
                    this.end = eastern.clone();
                    break;
                case 'last2years':
                    this.start = eastern.clone().subtract(2, 'years');
                    this.end = eastern.clone();
                    break;

                // Previous periods
                case 'yesterday':
                    this.start = eastern.clone().subtract(1, 'day').startOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(1, 'day').endOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'dayBeforeYesterday':
                    this.start = eastern.clone().subtract(2, 'days').startOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(2, 'days').endOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisDayLastWeek':
                    this.start = eastern.clone().subtract(1, 'week').startOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(1, 'week').endOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'previousWeek':
                    this.start = eastern.clone().subtract(1, 'week').startOf('week').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(1, 'week').endOf('week').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'previousMonth':
                    this.start = eastern.clone().subtract(1, 'month').startOf('month').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(1, 'month').endOf('month').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'previousYear':
                    this.start = eastern.clone().subtract(1, 'year').startOf('year').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().subtract(1, 'year').endOf('year').format("YYYY-MM-DDTHH:mm:ss");
                    break;

                // Current periods
                case 'today':
                    this.start = eastern.clone().startOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().endOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'todaySoFar':
                    this.start = eastern.clone().startOf('day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisWeek':
                    this.start = eastern.clone().startOf('week').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().endOf('week').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisWeekSoFar':
                    this.start = eastern.clone().startOf('week').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisMonth':
                    this.start = eastern.clone().startOf('month').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().endOf('month').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisMonthSoFar':
                    this.start = eastern.clone().startOf('month').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisYear':
                    this.start = eastern.clone().startOf('year').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().endOf('year').format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'thisYearSoFar':
                    this.start = eastern.clone().startOf('year').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;

                // Recent time
                case 'last5min':
                    this.start = eastern.clone().subtract(5, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last15min':
                    this.start = eastern.clone().subtract(15, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last30min':
                    this.start = eastern.clone().subtract(30, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last1hour':
                    this.start = eastern.clone().subtract(1, 'hour').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last3hours':
                    this.start = eastern.clone().subtract(3, 'hours').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last6hours':
                    this.start = eastern.clone().subtract(6, 'hours').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                case 'last12hours':
                    this.start = eastern.clone().subtract(12, 'hours').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone();
                    break;
                case 'last1day':
                    this.start = eastern.clone().subtract(1, 'day').format("YYYY-MM-DDTHH:mm:ss");
                    this.end = eastern.clone().format("YYYY-MM-DDTHH:mm:ss");
                    break;
            }

           return {start: this.start, end: this.end, selectedPreset: preset};

        },
    },
    mounted() {
        // Set default range when component is mounted
        this.setDateRange('last15min');
    }
};
